import { activeCurrencies, activePaymentMethods } from "utils";
import create from "zustand";
import { persist } from "zustand/middleware";

const currencyStore = (set) => ({
	currency: activeCurrencies.USD.code,
	paymentMethod: activePaymentMethods.ecocashUsd.name,

	setCurrency: (currencyToSet) => {
		set({ currency: currencyToSet });
		switch (currencyToSet) {
			case activeCurrencies.ZWL.code:
				set({ paymentMethod: activePaymentMethods.ecocashZwl.name });
				break;
			case activeCurrencies.USD.code:
				set({ paymentMethod: activePaymentMethods.ecocashUsd.name });
				break;
			default:
				set({ paymentMethod: activePaymentMethods.ecocashZwl.name });
				break;
		}
	},

	setPaymentMethod: (paymentMethodToSet) => {
		set({ paymentMethod: paymentMethodToSet });
		switch (paymentMethodToSet) {
			case activePaymentMethods.ecocashZwl.name:
				set({ currency: activeCurrencies.ZWL.code });
				break;
			case activePaymentMethods.paypal.name:
				set({ currency: activeCurrencies.USD.code });
				break;
			case activePaymentMethods.ecocashUsd.name:
				set({ currency: activeCurrencies.USD.code });
				break;
			case activePaymentMethods.stars.name:
				set({ currency: activeCurrencies.ZWL.code });
				break;
			case activePaymentMethods.voucher.name:
				// Voucher supports both currencies - don't change currency
				break;
			default:
				set({ currency: activeCurrencies.ZWL.code });
				break;
		}
	},
});

const useCurrencyStore = create(
	persist(currencyStore, { name: "zus-currency", getStorage: () => localStorage })
);
export default useCurrencyStore;
